<template>
  <div>
    <div v-if="!visiblePages.length">
      <div style="text-align: center; color: red; padding: 48px 16px;">
        No pages to display.
      </div>
    </div>

    <v-layout v-else row wrap class="email-files-toolbar mb-2" align-center>
      <v-btn
        small
        outline
        color="success"
        class="email-files-toolbar-btn ma-0 mr-2"
        @click="$emit('clear')"
      >
        Clear
      </v-btn>
      <v-btn
        small
        outline
        color="success"
        class="email-files-toolbar-btn ma-0 mr-2"
        @click="$emit('select-all')"
      >
        Select all
      </v-btn>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="searchText"
        outline
        hide-details
        class="email-files-search ma-0 pa-0"
        label="Search files"
        prepend-inner-icon="mdi-magnify"
      ></v-text-field> -->
    </v-layout>

    <v-layout row wrap>
      <v-flex
        v-for="page in visiblePages"
        :key="page.key"
        class="email-files-page-col pa-2"
      >
        <v-card
          class="email-files-page-card"
          :class="{ 'email-files-page-card--selected': isSelected(page) }"
          @click.native="$emit('toggle', page)"
        >
          <div class="email-files-page-preview">
            <div class="email-files-page-index">
              {{ page.index }}
            </div>
            <v-icon
              v-if="isSelected(page)"
              class="email-files-page-check"
              color="success"
            >
              mdi-check-circle
            </v-icon>
            <pdf
              v-if="page.kind === 'pdf'"
              class="email-files-thumb"
              :src="page.src"
              :page="page.pageNumber"
            ></pdf>
            <img
              v-else
              class="email-files-thumb-image"
              :src="page.src"
              :alt="page.fileName"
            />
          </div>
          <v-card-text class="email-files-page-footer pa-2">
            <div class="email-files-page-footer-text">
              <div class="email-files-page-name">
                {{ page.fileName }}
              </div>
              <div class="caption grey--text">Page {{ page.pageNumber }}</div>
            </div>
            <v-btn
              title="Open original file"
              icon
              class="email-files-page-open"
              @click.stop="openFile(page.fileURL, page.pageNumber)"
            >
              <v-icon small color="success">mdi-open-in-new</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import pdf from "vue-pdf";

export default {
  name: "EmailFilesPageGrid",
  components: {
    pdf,
  },
  props: {
    pages: {
      type: Array,
      default: function() {
        return [];
      },
    },
    selectedKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => {
    return {
      searchText: "",
    };
  },
  computed: {
    visiblePages() {
      const search = (this.searchText || "").toLowerCase().trim();
      if (!search) {
        return this.pages;
      }

      return this.pages.filter(function(page) {
        return (page.fileName || "").toLowerCase().indexOf(search) !== -1;
      });
    },
  },
  methods: {
    isSelected(page) {
      return this.selectedKeys.indexOf(page.key) !== -1;
    },
    openFile(fileURL, pageNumber) {
      window.open(fileURL + "#page=" + pageNumber);
    },
  },
};
</script>
<style>
.email-files-toolbar-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

/* .email-files-search {
  max-width: 280px;
} */

.email-files-page-col {
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: 100%;
}

.email-files-page-card {
  cursor: pointer;
  border-color: #ccf1ce !important;
  width: 100%;
  border: 2px solid;
  border-radius: 8px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.email-files-page-card:hover {
  border-color: #a5d6a7 !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.16) !important;
  transform: translateY(-1px);
}

.email-files-page-card--selected {
  border-color: #4caf50;
  box-shadow: 0 0 0 1px #4caf50, 0 4px 12px rgba(76, 175, 80, 0.2) !important;
}

.email-files-page-preview {
  position: relative;
  background: #f7f8f7;
  overflow: hidden;
}

.email-files-page-index {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  background: rgba(46, 125, 50, 0.88);
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
}

.email-files-page-check {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
  background: #fff;
  border-radius: 50%;
}

.email-files-thumb {
  display: block;
  width: 100%;
}

.email-files-thumb-image {
  display: block;
  width: 100%;
  height: auto;
}

.email-files-page-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: auto;
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.email-files-page-footer-text {
  min-width: 0;
  flex: 1 1 auto;
  padding-right: 8px;
}

.email-files-page-open {
  flex: 0 0 auto;
  margin: 0;
}

.email-files-page-name {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
